export default __webpack_public_path__ + "static/media/3_Still.b90c2cf7.jpg";